<template>
    <div class="vue-libs-radio-group">
        <template v-for="(label, id) in options">
            <input type="radio" v-bind:value="id" v-model="model" v-bind:id="id">
            <label class="btn btn-primary" v-bind:for="id">
                {{label}}
            </label>
        </template>
    </div>
</template>

<script>
export default {
    data() {
        return {
            model: this.value,
        };
    },
    props: [
        'options',
        'value',
    ],
    methods: {
    },
    components: {},
    watch: {
        model: function(){
            this.$emit('input',this.model)
        }
    }
}
</script>

<style>
.vue-libs-radio-group {
    border: 1px solid #52BA9F;
    border-radius: 5px;
}
.vue-libs-radio-group input[type="radio"] {
    display: none;
}
.vue-libs-radio-group label {
    border-right: 1px solid #52BA9F ;
    padding: 10px;
    color:#52BA9F ;
    padding-left: 30px;
    padding-right: 30px;
}
.vue-libs-radio-group label:last-child {
    border-right: none;
    margin-right: -4px;
    border-radius: 0 5px 5px 0;
}
.vue-libs-radio-group label:first-of-type {
    border-radius: 5px 0 0 5px;
    margin-left: -4px;
}
.vue-libs-radio-group input[type="radio"]:checked + label {
    color: white;
    background-color: #52BA9F;
}
</style>